import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Home from './pages/Home';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ClientDashboard from './pages/ClientDashboard';
import BrandingLaws from './pages/BrandingLaws';
import DotMoveCount from './pages/DotMoveCount';

const ProtectedRoute = ({ children, allowedRole }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (allowedRole && user.role !== allowedRole) return <Navigate to="/" />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-industrial-950 text-slate-100 relative overflow-hidden">
        {/* 3D Floating Background */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="bg-blob bg-blob-1"></div>
          <div className="bg-blob bg-blob-2"></div>
          <div className="bg-blob bg-blob-3"></div>
        </div>

        <Router>
          <div className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin/*" element={
                <ProtectedRoute allowedRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/laws" element={<BrandingLaws />} />
              <Route path="/admin/audit" element={<DotMoveCount />} />
              <Route path="/client/*" element={
                <ProtectedRoute allowedRole="client">
                  <ClientDashboard />
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </div>
    </AuthProvider>
  );
}
